<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'" (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>
<div class="page-contents" id="toplevelsub">
    <div class="subBlockContainer">
        <div class="breadcrumbWrapper">
            <app-breadcrumb *ngIf="cmsId && isBreadCrumbsUpdated" [inputbreadcrumbs]="breadcrumbs"></app-breadcrumb>
            <app-breadcrumb *ngIf="!cmsId"></app-breadcrumb>
        </div>
        <mat-sidenav-container class="sidenav-container" style="height: 100%; position: unset;background: white;" [hasBackdrop]="false">
            <div class="subBlockContent" *ngIf="!narrowMode">
                <child-header [title]="title" (closeEvent)="navigateTo('/home')"></child-header>
                <loading-screen *ngIf="!loadContent" [showInnerLoading]="true" (currentLoadingStatus)="onLoading($event)"></loading-screen>

                <div *ngIf="loadContent" class="inner-subBlock-wrapper">
                    <!-- <div class="page-title-wrapper">
                        <div class="title blade-title-font">
                            {{title}}
                        </div>
                        <i class="material-icons closebutton-pullfloat-right" [routerLink]="['/home']">close</i>
                    </div> -->
                    <div class="filter-wrapper">
                        <div class="col-md-3">
                            <div class="searchInputGroup toplevelsub" [class.narrowModeInput]="narrowMode">
                                <div class="searchIcon">
                                    <img src="../images/new_ui/filter.png">
                                </div>
                                <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''" onblur="this.placeholder='Filter'" [(ngModel)]="searchField">
                            </div>
                        </div>
                    </div>
                    <div class="top-divider"></div>
                </div>
                <div *ngIf="loadContent" class="child-body">
                    <div class="inner-subBlock-wrapper" *ngIf="activePrograms">
                        <div class="page-subtitle-wrapper" *ngIf="!narrowMode">ACTIVE</div>
                        <div class="noData-wrapper" *ngIf="!activePrograms.length">
                            <div>
                                <img src="../images/new_ui/no-subscription.png">
                            </div>
                            <label class="noData-label">
                    We couldn't find any <br />
                    subscriptions for this tenant
                </label>
                        </div>
                        <div class="logoList" *ngIf="activePrograms.length">
                            <ng-container *ngFor="let program of activePrograms | TableFilter: 'programDescription' : searchField">
                                <div class="manage-program-logo long-detail-logo">
                                    <div class="logo-content">
                                        <div>
                                            <!-- <a *ngIf="program?.cmsId" (click)="changeMode($event);" [routerLink]="['/manageSubscriptions', program.cmsId]"> -->
                                            <a *ngIf="program?.cmsId" (click)="changeMode($event);" [routerLink]="['/manageSubscriptions']" [queryParams]="{cmsId:program?.cmsId}">                        
                                                <!-- <img class="subscription-link" src="../images/new_ui/subscription-add.png"></a> -->
                                                <span class="basic-icon information-icon"></span>
                                            </a>
                                        </div>
                                        <!-- <div (click)="changeMode($event);" class="imagefooter"
                        [routerLink]="['manageAnnuities/' + program?.programType]"> -->
                                        <div (click)="changeMode($event);navigateToEndUser(program)" class="imagefooter">
                                            <img [src]="program.logo" [class.kaspersky]="program.programName.toLowerCase().includes('kaspersky')" />
                                            <div class="logo-footer">
                                                {{ program.programName }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    <div *ngIf="!narrowMode" class="discover-margin">
                        <div class="page-subtitle-wrapper">DISCOVER</div>
                        <div class="logoList">
                            <ng-container *ngFor="let discover of dicoverPrograms | TableFilter: 'programDescription' : searchField">
                                <div *ngIf="discover?.cmsId" class="manage-program-logo long-detail-logo" (click)="changeMode($event);navigateToCmsPage(discover)">                   
                                    <div class="logo-content">
                                        <div>
                                            <a>
                                                <!-- <img class="subscription-link dicover-link"
                            src="../images/new_ui/subscription-add.png"> -->
                                                <span class="basic-icon information-icon"></span>
                                            </a>
                                        </div>
                                        <div (click)="changeMode($event);navigateToCmsPage(discover)"  class="imagefooter">
                                            <img [src]="discover.logo" class="dicover-logo" />
                                            <div class="logo-footer">
                                                {{ discover.programName }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
            <div class="blockContainer narrow-sidebar subBlockContainer_toplevel" id='levelOne' *ngIf="narrowMode">
                <div class="combination-loader csp-loader" style="display: flex">
                    <div class="child-sidebar" style="border-right: 1px solid #dee2e6;">
                        <div [class.loader-border]="hideFirstLevel">
                            <child-header [title]="title" (closeEvent)="close()"></child-header>
                            <!-- <div class="page-title-wrapper">
                                <div class="title blade-title-font">
                                    {{title}}
                                </div>
                                <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
                            </div> -->
                            <div class="child-body">
                                <div class="searchInputGroup">
                                    <div class="searchIcon search-carts">
                                        <img src="../images/new_ui/filter.png">
                                    </div>
                                    <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''" onblur="this.placeholder='Filter'" [(ngModel)]="searchField">
                                </div>

                                <ng-container *ngFor="let item of activePrograms | TableFilter: 'programDescription' : searchField">
                                    <div class="menu-wrapper" [class.active]="isActive(item?.programType, item?.cmsId)" (click)="cms=null;navigateToEndUser(item)">
                                        <!-- <span class="row small-logo">
                        <img style="margin-left:10px;" [src]="item.logo">
                        </span>
                        &nbsp; -->
                                        <!-- <label (click)="cms=null;navigateToEndUser(item)" [routerLink]="['manageAnnuities/' + item?.programType]"
                        class="small-title">{{item.programName}}</label> -->
                                        <label  class="small-title">{{item.programName}}</label>
                                        <!-- <a *ngIf="item?.cmsId" [routerLink]="['/manageSubscriptions', item?.cmsId]"> -->
                                            <a *ngIf="item?.cmsId" (click)="$event.stopPropagation()" [routerLink]="['/manageSubscriptions']"  [queryParams]="{cmsId:item?.cmsId}">
                                            <!-- <img class="subscription-link"
                            src="../images/new_ui/subscription-add.png"> -->
                                            <span class="basic-icon information-icon information-icon-position"></span>
                                        </a>
                                    </div>
                                </ng-container>

                                <ng-container *ngFor="let item of dicoverPrograms | TableFilter: 'programDescription' : searchField">
                                    <!-- <div *ngIf="item?.cmsId" class="menu-wrapper menu-disabled"  [routerLink]="['/manageSubscriptions', item?.cmsId]"> -->
                                        <div *ngIf="item?.cmsId" class="menu-wrapper menu-disabled"  (click)="navigateToCmsPage(item)">
                                        <!-- <span class="row small-logo">
                        <img style="margin-left:10px;" class="dicover-logo" [src]="item.logo">
                        </span>
                        &nbsp; -->
                                        <label class="small-title">{{item.programName}}</label>
                                        <a>
                                            <!-- <img class="subscription-link" src="../images/new_ui/subscription-add.png"> -->
                                            <span class="basic-icon information-icon information-icon-position"></span>
                                        </a>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                    <div class="child-loader">
                        <router-outlet *ngIf="!cms"></router-outlet>
                        <div *ngIf="cms" class="subBlockContent">
                            <child-header [title]="title" (closeEvent)="closeCmsPage()"></child-header>
                            <div class="child-body">
                                <div class="inner-subBlock-wrapper">
                                    <!-- <div class="mat-toolbar-menu" *ngIf="showAddNewUserBtn">
                                        <button mat-button (click)="onCMSAddUser()" placement="bottom" ><i class="basic-icon addnewuser-icon"></i>+ Create New End User</button>
                                    </div> -->
                                    <!-- <div class="page-title-wrapper">
                                        <div class="title blade-title-font">
                                            {{cms?.title}}
                                        </div>
                                        <i class="material-icons closebutton-pullfloat-right" (click)="closeCmsPage()">close</i>
                                    </div> -->
                                    <!-- <i class="material-icons pullfloat-right text-right" (click)="cms = null">close</i> -->
                                    <div class="fr-view">
                                        <span [innerHTML]="cms?.innerHtml | sanitizeHtml" (click)="cmsClickEvent($event)"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <!-- right sidenav dynamic content -->
            <mat-sidenav #rightPanel class="right-sidenav-panel" position="end">
                <ng-template [cdkPortalOutlet]="panelService.panelPortal | async"></ng-template>
            </mat-sidenav>
        </mat-sidenav-container>
    </div>
</div>